import { useState } from "react";
import { ClipboardDocumentIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";

type PromptPreviewProps = {
  prompt: string;
};

export default function PromptPreview({ prompt }: PromptPreviewProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(prompt).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="bg-white dark:bg-darkbglight rounded-xl shadow-sm border border-gray-100 dark:border-gray-700">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-700">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Prompt Preview</h3>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-300 hover:border-entntblue hover:text-entntblue dark:hover:border-entntblue dark:hover:text-entntblue transition-colors"
        >
          {copied ? (
            <>
              <ClipboardDocumentCheckIcon className="h-3.5 w-3.5 text-emerald-500" />
              <span className="text-emerald-500">Copied</span>
            </>
          ) : (
            <>
              <ClipboardDocumentIcon className="h-3.5 w-3.5" />
              Copy
            </>
          )}
        </button>
      </div>
      <div className="px-6 py-5">
        <textarea
          readOnly
          value={prompt}
          className="w-full resize-none rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-darkbg px-3 py-3 font-mono text-xs leading-relaxed text-gray-700 dark:text-gray-300 focus:outline-none h-[calc(100vh-22rem)] min-h-64"
        />
      </div>
    </div>
  );
}
